$ = require 'jquery'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class ComposerLabelSelectorView extends View
  viewTitleKey: 'select labels'
  tagName: 'ul'
  className: 'edit-labels-pop-over'

  events:
    'mouseenter .item': 'hoverLabelSelect'
    'click .card-label': 'addOrRemoveLabel'

  populate: (@populatedLabelList) ->

  render: ->
    view = @
    labels = []

    currentLabels = @model.getLabels()

    labelList = @populatedLabelList ? @model.getBoard().getLabels()

    labels = for label in labelList
      isActive = _.include(currentLabels, label)
      {
        id: label.id
        color: label.get('color')
        name: label.get('name')
        isActive
      }

    data =
      labels: labels

    @$el.html(
      templates.fill(
        'select_labels',
        data
      )
    )

    Util.selectMenuItem(
      @$('.edit-labels-pop-over'),
      '.js-select-label',
      @$('.js-select-label').first()
    )
    @

  hoverLabelSelect: (e) ->
    Util.selectMenuItem(
      @$('.edit-labels-pop-over'),
      '.js-select-label',
      $(e.target).closest('.js-select-label')
    )

  addOrRemoveLabel: (e) ->
    Util.stop(e)
    $label = $(e.target).closest('.js-select-label')
    $label.toggleClass('active')
    idLabel = $label.attr('data-idlabel')
    if @model.toggleLabel(@modelCache.get('Label', idLabel))
      track('Card Composer', 'Add Label')
    else
      track('Card Composer', 'Remove Label')

    return



// WEBPACK FOOTER //
// ./app/scripts/views/card-composer/composer-label-selector-view.coffee